// Etiquetas Externas: Para el registro de etiquetas externas se debe definir 
// un campo input o select con el nombre "ete_#NUM#", Donde #NUM# es el identificador 
// de la etiqueta externa en Delio (Primera columna de la lista de etiquetas). 
// El valor de dicho campo debe ser la opción elegida de entre las opciones que dispone la etiqueta comercial. 
// El numero sera asignado por el orden en el que aparecen en la etiqueta.

// EJEMPLO:

// <select id="sexo" name="ete_50" >
//      <option value="0" selected="">Selecc

export function imprimirEtiquetasExt(configuracionLanding) {
  const etiquetasExternas = configuracionLanding.etiquetas.externas;
  const formularios = document.querySelectorAll('.wg-form');
  let newExternals = [];

  etiquetasExternas.forEach(etiqueta => {
    const { id, option } = etiqueta
    const hiddenExt = `<input type="hidden" name="ete_${id}" value="${option}" >`
    formularios.forEach((form) => {
      form.innerHTML += hiddenExt
    });

    newExternals.push(etiqueta);
    if (window.userLabels.EExternals) window.userLabels.EExternals = newExternals;
  });

  const loadLabelsInterval = setInterval(() => {
    if (typeof DRP != "function") return;
    clearInterval(loadLabelsInterval);
    DRP.loadLabels(window.userLabels);
  })
}
